import React, { useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box, Container, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import { esES as coreEsES } from '@mui/material/locale';
import { esES as pickersEsES } from '@mui/x-date-pickers/locales';
import { esES } from '@mui/x-data-grid/locales';
import AppDrawer from './AppDrawer';
import ShellAppBar from './ShellAppBar';

const dashboardTheme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
  },
  esES,
  pickersEsES,
  coreEsES
);

export default function DashboardLayout({ children }) {
  const isMobile = useMediaQuery(dashboardTheme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const toggleDrawer = () => {
    setOpen((previous) => !previous);
  };

  return (
    <ThemeProvider theme={dashboardTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <ShellAppBar open={open} toggleDrawer={toggleDrawer} isMobile={isMobile} />
        <AppDrawer open={open} toggleDrawer={toggleDrawer} isMobile={isMobile} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900]),
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container maxWidth={false} sx={{ mt: { xs: 2, md: 5 }, mb: { xs: 2, md: 5 }, px: { xs: 1.5, sm: 2, md: 3 } }}>
            {children}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
